var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { GoodDamageComponent } from '../GoodDamageComponent';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import NumberInput from '@declaration/components/NumberInput.vue';
import LengthInput from '@declaration/components/LengthInput.vue';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import { numbersToChoices } from '@shared/choice';
import { FRENCH_WINDOW_DAMAGE_TYPE_CHOICES, FRENCH_WINDOW_GLASS_TYPE_CHOICES, FRENCH_WINDOW_GLAZING_TYPE_CHOICES, FRENCH_WINDOW_LEAF_HEIGHT_CHOICES, FRENCH_WINDOW_MATERIAL_CHOICES, FRENCH_WINDOW_ONE_LEAF_WIDTH_CHOICES, FRENCH_WINDOW_TWO_LEAVES_WIDTH_CHOICES, } from '@shared/roomDamage/goodDamage';
import { FrenchWindowDamageType, FrenchWindowMaterial, } from '@shared/types/api/roomDamage';
let FrenchWindowDescription = class FrenchWindowDescription extends GoodDamageComponent {
    get leafCountLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.leaf_count');
    }
    get materialLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.material');
    }
    get damageTypeLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.damage_type');
    }
    get isGlazingBrokenLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.is_glazing_broken');
    }
    get tileCountLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.tile_count');
    }
    get biggestTileSizeLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.biggest_tile_size');
    }
    get biggestTileWidthLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.biggest_tile_width');
    }
    get biggestTileHeightLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.biggest_tile_height');
    }
    get glazingTypeLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.glazing_type');
    }
    get glassTypeLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.glass_type');
    }
    get leafWidthLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.leaf_width');
    }
    get leafHeightLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.opening.french_window.leaf_height');
    }
    get leafCountChoices() {
        return numbersToChoices(1, 2);
    }
    get materialChoices() {
        return FRENCH_WINDOW_MATERIAL_CHOICES;
    }
    get damageTypeChoices() {
        return FRENCH_WINDOW_DAMAGE_TYPE_CHOICES;
    }
    get hasGlazingChoices() {
        return YES_OR_NO_CHOICES;
    }
    get isGlazingBrokenChoices() {
        return YES_OR_NO_CHOICES;
    }
    get glazingTypeChoices() {
        return FRENCH_WINDOW_GLAZING_TYPE_CHOICES;
    }
    get glassTypeChoices() {
        return FRENCH_WINDOW_GLASS_TYPE_CHOICES;
    }
    get leafWidthChoices() {
        var _a;
        return ((_a = this.leafCount) !== null && _a !== void 0 ? _a : 1) >= 2
            ? FRENCH_WINDOW_TWO_LEAVES_WIDTH_CHOICES
            : FRENCH_WINDOW_ONE_LEAF_WIDTH_CHOICES;
    }
    get leafHeightChoices() {
        return FRENCH_WINDOW_LEAF_HEIGHT_CHOICES;
    }
    get leafCount() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.leafCount) !== null && _b !== void 0 ? _b : null;
    }
    set leafCount(leafCount) {
        this.updateGoodDamage({ leafCount });
    }
    get material() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.material) !== null && _b !== void 0 ? _b : null;
    }
    set material(material) {
        this.updateGoodDamage({
            material,
            damageType: material === FrenchWindowMaterial.WOOD ? this.damageType : null,
            isGlazingBroken: material === FrenchWindowMaterial.WOOD ? this.isGlazingBroken : null,
            tileCount: material === FrenchWindowMaterial.WOOD ? this.tileCount : null,
            biggestTileWidth: material === FrenchWindowMaterial.WOOD ? this.biggestTileWidth : null,
            biggestTileHeight: material === FrenchWindowMaterial.WOOD ? this.biggestTileHeight : null,
            leafWidth: material === FrenchWindowMaterial.PVC ||
                material === FrenchWindowMaterial.METAL ||
                this.damageType === FrenchWindowDamageType.DAMAGED
                ? this.leafWidth
                : null,
            leafHeight: material === FrenchWindowMaterial.PVC ||
                material === FrenchWindowMaterial.METAL ||
                this.damageType === FrenchWindowDamageType.DAMAGED
                ? this.leafHeight
                : null,
        });
    }
    get damageType() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.damageType) !== null && _b !== void 0 ? _b : null;
    }
    set damageType(damageType) {
        const aesthetic = damageType === FrenchWindowDamageType.AESTHETIC;
        this.updateGoodDamage({
            damageType,
            isGlazingBroken: aesthetic ? this.isGlazingBroken : null,
            tileCount: aesthetic ? this.tileCount : null,
            biggestTileWidth: aesthetic ? this.biggestTileWidth : null,
            biggestTileHeight: aesthetic ? this.biggestTileHeight : null,
            leafWidth: aesthetic ? null : this.leafWidth,
            leafHeight: aesthetic ? null : this.leafHeight,
        });
    }
    get isGlazingBroken() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.isGlazingBroken) !== null && _b !== void 0 ? _b : null;
    }
    set isGlazingBroken(isGlazingBroken) {
        this.updateGoodDamage({
            isGlazingBroken,
            tileCount: isGlazingBroken ? this.tileCount : null,
            biggestTileWidth: isGlazingBroken ? this.biggestTileWidth : null,
            biggestTileHeight: isGlazingBroken ? this.biggestTileHeight : null,
            glazingType: isGlazingBroken ? this.glazingType : null,
            glassType: isGlazingBroken ? this.glassType : null,
        });
    }
    get tileCount() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.tileCount) !== null && _b !== void 0 ? _b : 0;
    }
    set tileCount(tileCount) {
        this.updateGoodDamage({ tileCount });
    }
    get biggestTileWidth() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.biggestTileWidth) !== null && _b !== void 0 ? _b : 0;
    }
    set biggestTileWidth(biggestTileWidth) {
        this.updateGoodDamage({ biggestTileWidth });
    }
    get biggestTileHeight() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.biggestTileHeight) !== null && _b !== void 0 ? _b : 0;
    }
    set biggestTileHeight(biggestTileHeight) {
        this.updateGoodDamage({ biggestTileHeight });
    }
    get glazingType() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.glazingType) !== null && _b !== void 0 ? _b : null;
    }
    set glazingType(glazingType) {
        this.updateGoodDamage({ glazingType });
    }
    get glassType() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.glassType) !== null && _b !== void 0 ? _b : null;
    }
    set glassType(glassType) {
        this.updateGoodDamage({ glassType });
    }
    get leafWidth() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.leafWidth) !== null && _b !== void 0 ? _b : null;
    }
    set leafWidth(leafWidth) {
        this.updateGoodDamage({ leafWidth });
    }
    get leafHeight() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.leafHeight) !== null && _b !== void 0 ? _b : null;
    }
    set leafHeight(leafHeight) {
        this.updateGoodDamage({ leafHeight });
    }
    get shouldDescribeDamageType() {
        return this.material === FrenchWindowMaterial.WOOD;
    }
    get shouldDescribeIsGlazingBroken() {
        return this.damageType === FrenchWindowDamageType.AESTHETIC;
    }
    get shouldDescribeGlassDetails() {
        return (this.isGlazingBroken === true ||
            this.damageType === FrenchWindowDamageType.DAMAGED ||
            this.material === FrenchWindowMaterial.PVC ||
            this.material === FrenchWindowMaterial.METAL);
    }
    get shouldDescribeLeafDimensions() {
        return (this.damageType === FrenchWindowDamageType.DAMAGED ||
            this.material === FrenchWindowMaterial.PVC ||
            this.material === FrenchWindowMaterial.METAL);
    }
};
FrenchWindowDescription = __decorate([
    Component({ components: { RadioPrimaryButton, NumberInput, LengthInput } })
], FrenchWindowDescription);
export default FrenchWindowDescription;
